import { useMemo } from "react";

const useQueryString = <T>(param: T): string => {
  const queryString = useMemo(() => {
    return param
      ? Object.keys(param)
          .map((key) => key + "=" + param[key])
          .join("&")
      : "";
  }, [param]);

  return queryString;
};

export default useQueryString;
